import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum AuthRuleServiceEnum {
  save = "/save",
  getById = "/",
  getAll = "/",
  getGroups = "/groups",
  getBasic = "/basic",
  edit = "/edit"
}

export default class AuthRule extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/auth/rule");
  }
  public save = async data => await this.POST(AuthRuleServiceEnum.save, data);
  public getById = async id => await this.GET(AuthRuleServiceEnum.getById + id);
  public getAll = async () => await this.GET(AuthRuleServiceEnum.getAll);
  public getGroups = async () => await this.GET(AuthRuleServiceEnum.getGroups);
  public getBasicAll = async () => await this.GET(AuthRuleServiceEnum.getBasic);
  public edit = async data => await this.PUT(AuthRuleServiceEnum.edit, data);
}


// WEBPACK FOOTER //
// ./src/services/api/AuthRule.service.ts